import React, { useEffect, useState } from "react";
import "./Shop.css";
import Banner from "../../images/banner.jpg";

import { db } from "../../firebase/firebase";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import NavBar from "../Layout/NavBar";
import { useLocation, useNavigate } from "react-router-dom";
import { loadProductAnalytics } from "../../utils/loadProductAnalytics";

import Footer from "../Footer/Footer";

const siteType = process.env.REACT_APP_SITE_TYPE;

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [categoryInfo, setCategoryInfo] = useState(null);
  const itemsPerPage = 20;

  const location = useLocation();
  const navigate = useNavigate();

  // Determine category from URL
let path = location.pathname;

// Remove leading slash
path = path.replace(/^\//, "");

// Remove "shop/" prefix if present
path = path.replace(/^shop\//, "");

// MAIN site default
if (siteType === "MAIN" && (path === "" || path === "shop")) {
  path = "coloring-books";
}

useEffect(() => {
  if (path === "blog") {
    navigate("/blog", { replace: true });
  }
}, [path, navigate]);

  useEffect(() => {
    async function loadCategoryInfo() {
      try {
        const snap = await getDocs(collection(db, "categories"));
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

        const active = list.find((c) => c.slug === path);
        setCategoryInfo(active || null);
      } catch (err) {
        console.error("Error loading category info:", err);
      }
    }

    loadCategoryInfo();
  }, [path]);

  // Fetch products for this category
  useEffect(() => {
    async function fetchProducts() {
      try {
        const q = query(
          collection(db, "products"),
          where("category", "==", path),   // ← FIXED: matches ProductForm slug
          orderBy("createdAt", "desc")
        );

        const snapshot = await getDocs(q);
        const list = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setProducts(list);
        setCurrentPage(1);
      } catch (error) {
        console.error("Error loading products:", error);
      }
    }

    fetchProducts();
  }, [path]);

  useEffect(() => {
    async function load() {
      const merged = await loadProductAnalytics(30);
      const filtered = merged.filter(p => p.category === path);
      setProducts(filtered);
    }
    load();
  }, [path]);


  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentProducts = products.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(products.length / itemsPerPage);

  return (
    <div className="shop-container">
      {/* Banner Image */}
      <div className="shop-banner">
        <img src={Banner} alt="Shop Banner" />
      </div>

      {siteType === "MAIN" && (
        <div className="shop-back">
          <a href="/">← Back</a>
        </div>
      )}

      {/* Category Nav */}
      <NavBar />

      {categoryInfo && (
        <div className="category-header">
          <h1 className="category-title">{categoryInfo.name}</h1>
          <p className="category-headline">{categoryInfo.headline}</p>
        </div>
      )}


      <div className="product-grid">
        {currentProducts.map((product) => {
          return (
            <div
              className="product-card"
              key={product.id}
              onClick={() => {
                const productUrl =
                  siteType === "SHOP"
                    ? `/shop/${path}/${product.id}`
                    : `/shop/${path}/${product.id}`;

                navigate(productUrl);
              }}
            >
              <div className="product-image-wrapper">
                {/* Main Image */}
                <img
                  src={product.image}
                  alt={product.title}
                  className="product-image main-image"
                  loading="lazy"
                />

                {/* Hover Image */}
                {product.image2 && (
                  <img
                    src={product.image2}
                    alt={product.title}
                    className="product-image hover-image"
                    loading="lazy"
                  />
                )}
              </div>

              <div className="product-info">
                <h2 className="product-title">{product.title}</h2>

                <div className="product-bottom">

                  <div className="product-meta-row">
                    <div className="product-tags">
                      {product.tags?.slice(0, 3).map((tag, i) => (
                        <span key={i} className="product-tag">{tag}</span>
                      ))}
                    </div>

                    <div className="product-likes">
                      {product.likes || 0}
                    </div>

                  </div>
                </div>
              </div>

            </div>
          );
        })}
      </div>


      {/* Pagination */}
      <div className="pagination">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
        >
          ← Previous
        </button>

        <span>
          Page {currentPage} of {totalPages}
        </span>

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(currentPage + 1)}
        >
          Next →
        </button>
      </div>

      <Footer />

    </div>
  );
};

export default Shop;